console.log("Japanese language UI loaded");

let labels = {
    "Dictionary" : "辞書",
    "Community" : "コミュニティ",
    "Learning" : "教材",
    "Textbook" : "教科書",
    //"Full Set of Rules" : "Полный список правил",
    "Reading" : "読書",
    "Game" : "ゲーム",
    "Transliterations" : "字訳",
    "We have found $n translations. Choose the one that fits your context:" : "$n件の翻訳が見つかりました。あなたの文脈に当たるのを選んでください",
    "Meaning" : "意味",
    "Possible translations" : "可能な翻訳",
    "Example" : "例",
    "Select the language" : "言語を選んでください",
    "Other" : "その他",

    'Belarusian' : "ベラルーシ語",
    'Bulgarian' : "ブルガリア語",
    'Cantonese' : "広東語",
    'Dutch' : "オランダ語",
    'Mandarin' : "中国語",
    'Czech' : "チェコ語",
    'English' : "英語",
    'Finnish' : "フィンランド語",
    'French' : "フランス語",
    'German' : "ドイツ語",
    'Greek' : "ギリシャ語",
    'Italian' : "イタリア語",
    'Japanese' : "日本語",
    'Korean' : "韓国語",
    'Malay' : "マレー語",
    'Polish' : "ポーランド語",
    'Russian' : "ロシア語",
    'Slovak' : "スロバキア語",
    'Spanish' : "スペイン語",
    'Turkish' : "トルコ語",
    'Ukrainian' : "ウクライナ語",
    'Vietnamese' : "ベトナム語"
};

//import FullSetOfRules from '@/components/full-set-of-rules/ja'

export default {
	labels, components: {
        //FullSetOfRules
    }
}